'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var LeftArrow = {};

exports.__exports = LeftArrow;
